import { render, staticRenderFns } from "./ResponsibilitiesCalendar.vue?vue&type=template&id=53ba1469&"
import script from "./ResponsibilitiesCalendar.vue?vue&type=script&lang=js&"
export * from "./ResponsibilitiesCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports